import AiAgentModelHistory from '../../../../../components/units/Management/AiAgent/Model/History';

export default function AiAgentModelHistoryPage() {
  return <AiAgentModelHistory />;
}
